import { render, staticRenderFns } from "./Meus-dados.vue?vue&type=template&id=2f375e7c&scoped=true&"
import script from "./Meus-dados.vue?vue&type=script&lang=js&"
export * from "./Meus-dados.vue?vue&type=script&lang=js&"
import style0 from "./Meus-dados.vue?vue&type=style&index=0&id=2f375e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f375e7c",
  null
  
)

export default component.exports